import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { FormatPhoneNumbersPipeModule } from 'src/app/pipes/format-phone-numbers/format-phone-numbers-pipe.module';
import { FormatSecondsPipeModule } from 'src/app/pipes/format-seconds/format-seconds-pipe.module';
import { CallLogDialogComponent } from './call-log-dialog.component';

@NgModule({
   declarations: [CallLogDialogComponent],
   imports: [
      CommonModule,
      MatDialogModule,
      MatButtonModule,
      FormatPhoneNumbersPipeModule,
      FormatSecondsPipeModule,
      LcsResponsiveTableModule,
      RouterModule,
   ],
   providers: [CallLogDialogComponent, DatePipe],
})
export class CallLogDialogModule {}
